export function getCopay(
  patientResponsibility: { total: number } | undefined,
  diagnoses: string[] | undefined
) {
  if (patientResponsibility) {
    return patientResponsibility.total / 100
  }
  if (diagnoses?.length) {
    return 0
  }
  return 25
}
